import React from 'react'
import Head from 'next/head'

const DeIndex: React.FC = () => (
  <Head>
    <meta name="robots" content="noindex, nofollow" />
  </Head>
)

export default DeIndex
